/**
 * Spanish (es) mappings for Settings
 */

export const settingsES = {
  // Page title
  "Settings": "Configuración",

  // Navigation sections
  "Profile": "Perfil",
  "Update your personal information and preferences": "Actualiza tu información personal y preferencias",
  "Achievements": "Logros",
  "Track your achievements and rewards": "Rastrea tus logros y recompensas",
  "Subscription": "Suscripción",
  "Manage your subscription plan and billing": "Administra tu plan de suscripción y facturación",
  "Notifications": "Notificaciones",
  "Customize your notification preferences": "Personaliza tus preferencias de notificación",
  "Bet History": "Historial de Apuestas",
  "Your betting analytics and history": "Tus análisis y historial de apuestas",
  "Privacy & Security": "Privacidad y Seguridad",
  "Manage your privacy settings and security options": "Administra tu configuración de privacidad y opciones de seguridad",
  "Appearance": "Apariencia",
  "Customize the look and feel of your experience": "Personaliza la apariencia de tu experiencia",
  "Language": "Idioma",
  "Choose your preferred language": "Elige tu idioma preferido",

  // Profile section
  "Account Information": "Información de Cuenta",
  "Email": "Correo Electrónico",
  "Display Name": "Nombre de Usuario",
  "Member Since": "Miembro Desde",
  "Account Status": "Estado de Cuenta",
  "Active": "Activo",
  "Free": "Gratis",
  "Pro": "Pro",
  "Sign in to manage your account settings": "Inicia sesión para administrar la configuración de tu cuenta",

  // Language section (new)
  "Language Preferences": "Preferencias de Idioma",
  "Choose your preferred language for the platform": "Elige tu idioma preferido para la plataforma",
  "The platform will automatically detect your browser language. You can override this by selecting a language above.": "La plataforma detectará automáticamente el idioma de tu navegador. Puedes cambiarlo seleccionando un idioma arriba.",

  // Subscription section
  "Subscription Management": "Administración de Suscripción",
  "Current Plan": "Plan Actual",
  "Upgrade": "Actualizar",
  "Manage Subscription": "Administrar Suscripción",

  // Coming soon
  "Coming Soon": "Próximamente",
  "We're crafting an amazing experience for this feature. Stay tuned for updates!": "¡Estamos creando una experiencia increíble para esta función. Mantente atento a las actualizaciones!",

  // Logout
  "Sign Out": "Cerrar Sesión",
  "Are you sure you want to log out of your account?": "¿Estás seguro de que quieres cerrar sesión en tu cuenta?",
  "Cancel": "Cancelar",
  "Confirm": "Confirmar",

  // Mobile
  "Close menu": "Cerrar menú",
  "Swipe to navigate": "Desliza para navegar",

  // Common
  "Save": "Guardar",
  "Edit": "Editar",
  "Delete": "Eliminar",
  "Back": "Atrás"
};
